module.exports = "/_next/static/images/coming-soon-other-cases-befbfee722f7f640d5c255d59b3adbf7.png";